<template>
  <div
    class="chat-page"
    :class="{
      'chat-page--dark': isDarkMode,
      'chat-page--light': !isDarkMode
    }"
  >
    <ChatSidebar :open="sidebarOpen" @toggle="sidebarOpen = !sidebarOpen" @close="sidebarOpen = false" />
    <ChatArea :sidebar-open="sidebarOpen" @toggle-sidebar="sidebarOpen = !sidebarOpen" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChatSidebar from '@/components/chat/ChatSidebar.vue';
import ChatArea from '@/components/chat/ChatArea.vue';

export default {
  name: 'ChatPage',
  components: { ChatSidebar, ChatArea },
  data() {
    return {
      sidebarOpen: typeof window !== 'undefined' ? window.innerWidth >= 768 : true
    };
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode'])
  },
  mounted() {
    this.$store.dispatch('chat/fetchConversations');
  }
};
</script>

<style scoped>
.chat-page {
  display: flex;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.chat-page--light {
  background: linear-gradient(160deg, #f8f9fc 0%, #eef1f8 50%, #f5f6fa 100%);
  color: #2c3e50;
}

.chat-page--dark {
  background: linear-gradient(160deg, #2b3035 0%, #343a40 50%, #2e3338 100%);
  color: #f0f0f0;
}

@media (min-width: 768px) {
  .chat-page {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
  }
}

@media (max-width: 767px) {
  .chat-page {
    flex-direction: column;
  }
}
</style>
